module.exports = "/ui/main/images/add_to_cart_disabled.png?4c7d18d4f02a1589c75429fd610b913b";